import type {
  OutboxItem,
  PullResult,
  PushResult,
  SyncTransport,
} from '@equiview/sync';
import type { SupabaseClient } from '@supabase/supabase-js';

/**
 * Transporte de sincronizacao sobre o PostgREST do Supabase.
 *
 * Chama as MESMAS funcoes SQL (`sync_push`, `sync_pull`) que os testes exercitam
 * contra um Postgres real. Se o teste passa, este caminho passa — nao ha uma
 * segunda implementacao para divergir.
 */
export class SupabaseTransport implements SyncTransport {
  constructor(private readonly client: SupabaseClient) {}

  async push(batch: OutboxItem[], deviceId: string): Promise<PushResult> {
    const { data, error } = await this.client.rpc('sync_push', {
      p_batch: batch,
      p_device_id: deviceId,
    });
    if (error) throw new Error(`sync_push: ${error.message}`);
    return data as PushResult;
  }

  async pull(since: number, limit: number): Promise<PullResult> {
    const { data, error } = await this.client.rpc('sync_pull', {
      p_since: since,
      p_limit: limit,
    });
    if (error) throw new Error(`sync_pull: ${error.message}`);
    return data as PullResult;
  }
}
